import React from 'react';
import { Box, BoxProps } from '@mui/material';

interface LogoProps extends Omit<BoxProps, 'component'> {
  variant?: 'icon' | 'icon-white' | 'horizontal' | 'vertical';
  width?: number | string;
  height?: number | string;
  alt?: string;
}

const AsuretiLogo: React.FC<LogoProps> = ({ 
  variant = 'icon', 
  width,
  height,
  alt = 'Asureti Logo',
  sx,
  ...props 
}) => {
  // Default dimensions for each variant
  const getDefaultDimensions = () => {
    switch (variant) {
      case 'icon':
      case 'icon-white':
        return { width: width || 40, height: height || 48 };
      case 'horizontal':
        return { width: width || 200, height: height || 60 };
      case 'vertical':
        return { width: width || 120, height: height || 140 };
      default:
        return { width: width || 40, height: height || 48 };
    }
  };

  // Image file paths (these will be in public/images/)
  const getImagePath = () => {
    switch (variant) {
      case 'icon':
        return '/images/asureti-logo-icon.jpg';
      case 'icon-white':
        return '/images/asureti-logo-icon-white.png';
      case 'horizontal':
        return '/images/asureti-logo-horizontal.png';
      case 'vertical':
        return '/images/asureti-logo-vertical.png';
      default:
        return '/images/asureti-logo-icon.jpg';
    }
  };

  const dimensions = getDefaultDimensions();

  return (
    <Box
      component="img"
      src={getImagePath()}
      alt={alt}
      sx={{
        width: dimensions.width,
        height: dimensions.height,
        objectFit: 'contain',
        ...sx
      }}
      {...props}
    />
  );
};

export default AsuretiLogo;
